.link {
	all: unset;
	color: var(--color-primary-foreground);
	text-decoration: none;
	cursor: revert-layer;

	&:hover {
		text-decoration: underline;
		text-decoration-thickness: 0.1em;
		text-underline-offset: 0.15em;
	}
}
